import { gql } from '@apollo/client';

export default gql`
  fragment pipelineIntegration on pipeline_integrations {
    id
    pipelineId
    integrationId
    disabled
  }
`;
